export const EDeliveryType = {
  SFTP: "sftp",
  FAX: "fax",
  MAIL: "mail",
  EXTERNAL_MEDIUM: "external_medium",
} as const;
